<div #userDetailsSection tabindex='-1' class='sso-user-details'>
  <div class='user-details'>
    <h2>{{localeTexts?.signupTab?.noNameHeader}}</h2>
    <p>{{localeTexts?.signupTab?.noNameSubHeader}}</p>
    <form 
      [formGroup]="form" 
      (ngSubmit)='onSubmit()'
    >
    <div *ngIf='errorMessage' class='sso-error-message' role="alert">
      <mat-icon aria-hidden='true'>error</mat-icon>
      <div>{{errorMessage}}</div>
    </div>

      <div class='sso-row sso-gender-group'>
        <aa-radio-button
          [groupName]="'sso-user-gender'"
          [id]="'sso-user-gender-input'"
          [dataList]="genderOptions"
          formControlName="gender"
          [form]="form"
        >
        ></aa-radio-button>
      </div>
      <div class='sso-user-details-inputs'>
        <div class='sso-row sso-given-name'>
          <aa-input
            [id]="'sso-user-given-name-input'"
            [labelText]="localeTexts?.signupTab?.givenName"
            formControlName="firstName"
            [form]="form"
            [autocomplete]="'given-name'"
            [error]="errorFirstName"
            [tooltipText]="localeTexts?.main?.tooltipText"
          >
          </aa-input>
        </div>
        <div class='sso-row sso-family-name'>
          <aa-input
            [id]="'sso-user-given-name-input'"
            [labelText]="localeTexts?.signupTab?.familyName"
            formControlName="lastName"
            [form]="form"
            [autocomplete]="'family-name'"
            [error]="errorLastName"
            [tooltipText]="localeTexts?.main?.tooltipText"
          >
          </aa-input>
        </div>

        <div *ngIf='isFromWeChat' class='sso-row sso-email'>
          <aa-input
            [id]="'sso-user-email-input'"
            [labelText]="localeTexts?.main?.email"
            formControlName="email"
            [form]="form"
            [type]="'email'"
            [autocomplete]="'email'"
            [error]="errorEmail"
            [maxLength]='64'
          >
          </aa-input>
        </div>

        <div class='sso-row sso-user-button'>
          <button type='submit' #submitButton class='sso-button' [disabled]='isLoading'>
            <mat-spinner *ngIf='isLoading' class='white-spinner' [diameter]="22"></mat-spinner>
            <ng-container *ngIf='!isLoading'>
                {{localeTexts?.signupTab?.save}}
            </ng-container>
          </button>
        </div>

      </div>
    </form>
  </div>
</div>
